import * as o from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/Video.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...r, weights: i }));
e.displayName = "VideoIcon";
const s = e;
export {
  s as Video,
  e as VideoIcon
};
